export interface HelloGeneratorSchema {
  directory: string;
}
